import { CitiesFooter } from '@dreamstack/accentro-contentful/src/components/CitiesFooter'
import { ContactFooter } from '@dreamstack/feature-components/src/footer/ContactFooter'
import { GridWithGapsAndPadding } from '@dreamstack/feature-components/src/layout/MainGrid'
import { cn } from '@dreamstack/util/src/cn'
import type { FunctionComponent } from 'react'

const FooterLeftHalf = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <div
    className={cn(
      'flex flex-col w-full md:w-1/2 flex-wrap min-w-0 shrink',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)
const FooterRightHalf = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <div
    className={cn(
      'flex flex-col w-full md:w-1/2 flex-wrap min-w-0 shrink',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

const CitiesGrid = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <GridWithGapsAndPadding
    className={cn(
      'min-w-0 pt-px-64 pb-px-128 bg-accentroGray-full text-accentroWhite-full border-accentroWhite-full border-b-2 space-y-px-24 md:space-y-0 md:pt-px-80',
      className
    )}
    {...rest}
  >
    {children}
  </GridWithGapsAndPadding>
)

export const CitiesContactFooter: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  return (
    <CitiesGrid>
      <div className="col-start-1 col-span-12 flex flex-wrap space-y-px-64 md:space-y-0">
        <FooterLeftHalf>
          <CitiesFooter />
        </FooterLeftHalf>
        <FooterRightHalf>
          <ContactFooter />
        </FooterRightHalf>
      </div>
    </CitiesGrid>
  )
}
